module.exports = __webpack_public_path__ + "media/svg/ws-f75cf826.svg";